import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'child-cell',
  template: `
    <div class="flex align-items-center list-user-action">
    <ng-container>
        <a class="" href="javascript:void(0)" title="Edit"
           (click)="invokeParentEditMethod()">
            <i class="bx bx-edit text-success me-1 font-size-16"></i>
        </a>
    </ng-container>
    <ng-container>
        <a class="" href="javascript:void(0)" title="Share"
           (click)="invokeParentShareToMethod()">
            <i class="bx bx-share-alt text-primary me-1 font-size-16"></i>
        </a>
    </ng-container>
    <ng-container>
        <a class="" href="javascript:void(0)" title="Delete"
           (click)="invokeParentDeleteMethod()">
            <i class="bx bx-trash text-danger me-1 font-size-16"></i>
        </a>
    </ng-container>
</div>

  `,
  styles: [
    `
      .btn {
        line-height: 0.5;
      }
    `,
  ],
})
export class EditShareDeleteActionsRenderer implements ICellRendererAngularComp {
  public params!: ICellRendererParams;
  isLoginTypeCustomer: boolean;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.isLoginTypeCustomer = params.context.isLoginTypeCustomer;
  }

  public invokeParentEditMethod() {
    this.params.context.componentParent.editAction(this.params.node.data);
  }

  public invokeParentShareToMethod() {
    this.params.context.componentParent.shareAction(this.params.node.data);
  }

  public invokeParentDeleteMethod() {
    this.params.context.componentParent.deleteAction(this.params.node.data);
  }

  refresh(): boolean {
    return false;
  }
}
